import { dust2PhysicsManifest } from "./maps/dust2.js";
import { mapPhysicsSetupManifests } from "./maps/catalog.js";
import { validateMapPhysicsAssetManifest } from "./validate-map-asset.js";
const manifests = [
    ...mapPhysicsSetupManifests,
    dust2PhysicsManifest,
];
for (const manifest of manifests) {
    validateMapPhysicsAssetManifest(manifest);
}
export function getMapPhysicsAssetManifest(mapId) {
    return (manifests.find((manifest) => {
        const manifestMapId = manifest.status === "validated" ? manifest.asset.mapId : manifest.mapId;
        return manifestMapId === mapId;
    }) ?? null);
}
export function getValidatedMapPhysicsAsset(mapId, mapRevision) {
    const manifest = getMapPhysicsAssetManifest(mapId);
    if (manifest?.status !== "validated" ||
        manifest.asset.mapRevision !== mapRevision) {
        return null;
    }
    return manifest.asset;
}
/**
 * Alle Karten, für die ein Physik-Manifest existiert — sortiert und stabil.
 *
 * Die Liste stand bis Phase 12 zusätzlich in drei `scripts/*.mjs`, jede als
 * eigenes Array. Eine neue Karte hätte an vier Stellen ergänzt werden müssen,
 * und ein Vergessen wäre erst beim nächsten Import aufgefallen.
 */
export const mapPhysicsIds = manifests
    .map((manifest) => manifest.status === "validated" ? manifest.asset.mapId : manifest.mapId)
    .sort();
